import MShare from '@mfex/mshare';

export interface ShareConfig {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
}

export function initShare(config: ShareConfig) {
    return new MShare(config);
}
